// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"homeStyle_mainContainer__2ICL3","headerContainer":"homeStyle_headerContainer__3yj2Q","titleContainer":"homeStyle_titleContainer__1gGyd"};